import { useEditor } from "../state/editor";
import { calcularCotizacion } from "../domain/pricing";
import { useConfirmar } from "./Dialogos";
import { moneda } from "../domain/model";
import { cotizacionesPropuestas } from "../domain/propuestas";
import Icono from "./Icono";
export default function Propuestas() {
  const c = useEditor((s) => s.cotizacion),
    propuestas = useEditor((s) => s.propuestas),
    agregar = useEditor((s) => s.agregarPropuesta),
    cambiar = useEditor((s) => s.cambiarPropuesta),
    quitar = useEditor((s) => s.quitarPropuesta);
  const confirmar = useConfirmar();
  const todas = cotizacionesPropuestas(c, propuestas);
  return (
    <section className="propuestas" aria-label="Propuestas alternativas">
      {propuestas.length > 1 ? (
        <>
          <p className="muted">
            Cada propuesta tiene su propio total. Los datos del cliente y las
            condiciones son compartidos.
          </p>
          <div className="proposal-list">
            {todas.map((p) => (
              <div
                className="proposal-tab"
                key={p.numero}
                data-active={p.numero === c.numero || undefined}
              >
                <button
                  type="button"
                  aria-pressed={p.numero === c.numero}
                  onClick={() => cambiar(p.numero)}
                >
                  <span>{p.etiquetaPropuesta}</span>
                  <strong>{moneda(calcularCotizacion(p).total)}</strong>
                </button>
                <button
                  type="button"
                  className="quitar-propuesta"
                  aria-label={`Quitar ${p.etiquetaPropuesta}`}
                  onClick={async () => {
                    if (
                      await confirmar({
                        titulo: `Quitar ${p.etiquetaPropuesta}`,
                        mensaje:
                          "Se saca de esta comparación. Los registros ya guardados se conservan en el historial.",
                        confirmar: "Quitar",
                        peligro: true,
                      })
                    )
                      quitar(p.numero);
                  }}
                >
                  <Icono nombre="cerrar" />
                </button>
              </div>
            ))}
          </div>
        </>
      ) : null}
      <button type="button" className="agregar-bloque" onClick={agregar}>
        <Icono nombre="agregar" /> Agregar otra propuesta
      </button>
    </section>
  );
}
